import './vendor';

import { bootstrap } from 'angular';
import app from './app/app.module';

const langs = require('../../langs.json');
for (let lang of langs) {
   if (lang.code != 'en') {
      require(`./po/${lang.code}`);
      // console.debug(`Loading po file ${lang.code}`);
   }
}

import './asset/scss/main';

import './legacy';

bootstrap(document, [app.name], { strictDi: true });
